import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Paper,
} from '@mui/material';

import { Page, EnhancedTable } from 'components';
import { useMisc } from 'store';

// some common columns
// the actual used columns are specified dynamically in dataUrl
const formatPrice = (row, col) => parseFloat(row[col]).toFixed(2);
const columns = [
  { name: 'org' },
  { name: 'cost', format: formatPrice },
  { name: 'total_cost', format: formatPrice },
];
const setFormatOrg = (misc) => (row, col) => misc.org[row[col]];

const ExtraReports = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const misc = useMisc((state) => state.data);
  const [title, setTitle] = useState('Extra Reports');
  const [cols, setCols] = useState([]);

  const dim = location.pathname.slice(15); // /reports/extra/abc...
  if (!dim) {
    navigate('/errors/404');
  }

  useEffect(() => void(setCols(
    columns.map(col => {
      let format;
      if (col.name === 'org') format = setFormatOrg(misc);
      return format ? {...col, format} : col;
    })
  )), [misc]);

  const handleDataChange = useCallback(data => setTitle(data.title), []);

  return (
    <Page title={title}>
      <Paper sx={{p: 1, pb: 0, m: 2, mt: 1}}>
        <EnhancedTable
          stickyHeader
          columns={cols}
          dataUrl={`/reports/${dim}`}
          idColumn="id"
          dense={true}
          multiPage={false}
          onDataChange={handleDataChange}
        />
      </Paper>
    </Page>
  );
};

export default ExtraReports;
